module.exports = __webpack_public_path__ + "static/media/convention-4.b44fa93e.webp";